export const STORE_COOKIE_NAME = 'StoreCookie';
